import { NUM } from "@/lib/format";
import { cn } from "@/lib/utils";

const r2 = (v) => Math.round((Number(v) || 0) * 100) / 100;
export const magOf = (p) => r2(p?.qty_magaza);
export const depoOf = (p) => r2((Number(p?.quantity) || 0) - magOf(p));

// Depo · Mağaza stoğu — az yer kaplayan iki parçalı rozet (total: toplamı da gösterir)
export function StockSplit({ p, depo, magaza, unit, total = false, className, testid }) {
  const d = depo != null ? r2(depo) : depoOf(p);
  const m = magaza != null ? r2(magaza) : magOf(p);
  const u = unit ?? p?.unit ?? "";
  const seg = (v, base) => cn("px-1.5 inline-flex items-center gap-[3px]", v < 0 ? "bg-red-50 text-red-700" : v === 0 ? "bg-muted/70 text-muted-foreground" : base);
  return (
    <span className={cn("inline-flex items-stretch rounded-md border border-border overflow-hidden text-[10.5px] font-bold tabular-nums leading-[18px] whitespace-nowrap shrink-0", className)}
      title={`Depo ${NUM(d)} · Mağaza ${NUM(m)} · Toplam ${NUM(r2(d + m))} ${u}`} data-testid={testid}>
      <span className={seg(d, "bg-slate-100 text-slate-700")} data-testid={testid ? `${testid}-depo` : undefined}><span className="text-[8.5px] font-black opacity-60">DEPO</span>{NUM(d)}</span>
      <span className={cn(seg(m, "bg-teal-50 text-teal-700"), "border-l border-border")} data-testid={testid ? `${testid}-magaza` : undefined}><span className="text-[8.5px] font-black opacity-60">MAĞ</span>{NUM(m)}</span>
      {total && <span className="px-1.5 border-l border-border bg-card text-foreground"><span className="text-[8.5px] font-black opacity-50 mr-[3px]">TOP</span>{NUM(r2(d + m))} {u}</span>}
    </span>
  );
}
